var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBattery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3291 2.78671H12.8291V2.28671V0.5H15.0207V2.28671H15.5207V2.78671H17.5V17.5H0.5V2.78671H2.47825H2.97825V2.28671V0.5H5.17095V2.28671V2.78671H5.67095H12.3291ZM1.269 15.3353V15.8353H1.769H16.231H16.731V15.3353V4.95141V4.45141H16.231H1.769H1.269V4.95141V15.3353Z",
    fill: "#667085",
    stroke: "#667085"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.33478 8.92995V9.89689H3.14313V8.92995H5.33478Z",
    fill: "#667085",
    stroke: "#667085"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.143 8.92995H13.643V8.42995V7.3752H13.8801V8.42995V8.92995H14.3801H14.8569V9.89689H14.3801H13.8801V10.3969V11.4516H13.643V10.3969V9.89689H13.143H12.6652V8.92995H13.143Z",
    fill: "#667085",
    stroke: "#667085"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBattery);
export default __webpack_public_path__ + "static/media/battery.19322521b7423db459929344b14a06c0.svg";
export { ForwardRef as ReactComponent };